G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.ChainStatus = function(candy) {
  this.wrapperImg = null;
  this.hp = null;

  G.BoardCandy.CandyStatus.call(this, {
    hpMax: 3,
  });
};

G.BoardCandy.ChainStatus.prototype = Object.create(G.BoardCandy.CandyStatus.prototype);

G.BoardCandy.ChainStatus.prototype.init = function(candy, config, optHp) {
  G.BoardCandy.CandyStatus.prototype.init.call(this, candy, config);
  this.hp = parseInt(G.Utils.defined(optHp, 1));
  this.wrapperImg = G.makeImage(0, 0, "status_chain_"+this.hp, 0.5, candy);

  this.signals.onHpChange.add(function() {
    this.wrapperImg.changeTexture("status_chain_"+this.hp);
    this.signals.checkIfIsMatching.dispatch();
  }, this);
};

G.BoardCandy.ChainStatus.prototype.onMatch = function() {
  this.changeHp(this.hp-1);
  G.sb("fxTop").dispatch('burstChainAnim', this.candy, this.candy);
  return false;
};

G.BoardCandy.ChainStatus.prototype.remove = function() {
  G.sfx.brick_break.play();
  G.sb("onCollectableRemove").dispatch('chain',this.candy);
  game.add.tween(this.wrapperImg)
    .to({
      width: this.wrapperImg.width*1.5,
      height: this.wrapperImg.height*1.5,
      alpha: 0
    }, 1000, Phaser.Easing.Cubic.Out,true)
    .onComplete.add(function() {
      this.wrapperImg.destroy();
    },this)

  G.sb("fx").dispatch('changeCircle',this.candy);
  G.sb("fxTop").dispatch('burstChainAnim',this.candy,this.candy);
  G.sfx.chain_rattle.play();
};